<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => excludeShapesBys(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class matchSizeMenus extends Vue {
        get menuList() {
            return {
                list: [
                    { key: "excludeShape", label: this.$t("excludeShape") },
                    { key: "excludeConnector", label: this.$t("excludeConnector") },
                    { key: "excludeImage", label: this.$t("excludeImage") },
                ],
            };
        }
        excludeShapesBys(type) {
            window["_view"].excludeShapesBy(type);
            this.$track("select", "Remove from selection", type);
            this.$emit("closeDrop");
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "excludeShape": "去除形状",
    "excludeConnector": "去除连接线",
    "excludeImage": "去除图片"
  },
  "en": {
    "excludeShape": "Exclude Shape",
    "excludeConnector": "Exclude Connector",
    "excludeImage": "Exclude Image"
  },
  "fr": {
    "excludeShape": "Exclure la forme",
    "excludeConnector": "Exclure le connecteur",
    "excludeImage": "Exclure l'image"
  },
  "de": {
    "excludeShape": "Form ausschließen",
    "excludeConnector": "Connector ausschließen",
    "excludeImage": "Bild ausschließen"
  },
  "jp": {
    "excludeShape": "シェイプを除外",
    "excludeConnector": "コネクタを除外",
    "excludeImage": "画像を除外"
  },
  "es": {
    "excludeShape": "Excluir forma",
    "excludeConnector": "Excluir conector",
    "excludeImage": "Excluir imagen"
  },
  "pt": {
    "excludeShape": "Excluir forma",
    "excludeConnector": "Exclude Connector",
    "excludeImage": "Excluir imagem"
  },
  "it": {
    "excludeShape": "Escludi forma",
    "excludeConnector": "Escludi connettore",
    "excludeImage": "Escludi immagine"
  },
  "tw": {
    "excludeShape": "去除形狀",
    "excludeConnector": "去除連接線",
    "excludeImage": "去除圖片"
  }
}
</i18n>
